/**
 * Created by matheusmorett on 11/7/17.
 */

import React, {Component} from 'react';

import Top from './../../assets/img/icons/top.png';

import "./Text.scss";

export default class Text extends Component {

    static defaultProps = {
        backToTop: true
    };

    constructor(props){
        super(props);
    }

    handleBackToTheTop() {
        window.scrollTo({
            'behavior': 'smooth',
            'left': 0,
            'top': 0
        });
    }


    render() {

        const {title, items, children, backToTop} = this.props;
        return (
            <div className="Text">
                <div className="text-content">
                    <div className="title">
                        {title}
                    </div>
                    {items.map((i, index) => {
                        return (
                            <div id={i.id} key={index}>
                                <div className="sub-title">
                                    {i.title}
                                </div>
                                <div className="text">
                                    {i.text}
                                </div>
                            </div>    
                        )
                    })}
                    {children}
                    {(backToTop) ?
                        <div className="back-to-top Grid Grid--center" onClick={this.handleBackToTheTop.bind(this)}>
                            <div className="Grid Grid--center Grid-column">
                                <img src={Top} alt="Voltar ao topo"/>
                                Voltar ao topo
                            </div>
                        </div>
                        : ""
                    }
                </div>
            </div>
        )

    }

}